/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addRole } from '../fn/role/add-role';
import { AddRole$Params } from '../fn/role/add-role';
import { deleteRole } from '../fn/role/delete-role';
import { deleteRole_1 } from '../fn/role/delete-role-1';
import { DeleteRole_1$Params } from '../fn/role/delete-role-1';
import { DeleteRole$Params } from '../fn/role/delete-role';
import { getAllPermissions } from '../fn/role/get-all-permissions';
import { GetAllPermissions$Params } from '../fn/role/get-all-permissions';
import { getPermissionsByRoleId } from '../fn/role/get-permissions-by-role-id';
import { GetPermissionsByRoleId$Params } from '../fn/role/get-permissions-by-role-id';
import { getPermissionsByRoleName } from '../fn/role/get-permissions-by-role-name';
import { GetPermissionsByRoleName$Params } from '../fn/role/get-permissions-by-role-name';
import { getRoles } from '../fn/role/get-roles';
import { GetRoles$Params } from '../fn/role/get-roles';
import { getUsersByRoleId } from '../fn/role/get-users-by-role-id';
import { GetUsersByRoleId$Params } from '../fn/role/get-users-by-role-id';
import { PermissionName } from '../models/permission-name';
import { Role } from '../models/role';
import { RoleDto } from '../models/role-dto';
import { updateRole } from '../fn/role/update-role';
import { updateRole_1 } from '../fn/role/update-role-1';
import { UpdateRole_1$Params } from '../fn/role/update-role-1';
import { UpdateRole$Params } from '../fn/role/update-role';

@Injectable({ providedIn: 'root' })
export class RoleService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRoles()` */
  static readonly GetRolesPath = '/api/role';

  /**
   * Get Roles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Response(params?: GetRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoleDto>>> {
    return getRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Roles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles(params?: GetRoles$Params, context?: HttpContext): Observable<Array<RoleDto>> {
    return this.getRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RoleDto>>): Array<RoleDto> => r.body)
    );
  }

  /** Path part for operation `addRole()` */
  static readonly AddRolePath = '/api/role';

  /**
   * Add Role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addRole$Response(params: AddRole$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
    return addRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addRole(params: AddRole$Params, context?: HttpContext): Observable<Role> {
    return this.addRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<Role>): Role => r.body)
    );
  }

  /** Path part for operation `getPermissionsByRoleName()` */
  static readonly GetPermissionsByRoleNamePath = '/api/role/name/{roleName}';

  /**
   * Get Permissions By Role Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPermissionsByRoleName()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissionsByRoleName$Response(params: GetPermissionsByRoleName$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionName>>> {
    return getPermissionsByRoleName(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Permissions By Role Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPermissionsByRoleName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissionsByRoleName(params: GetPermissionsByRoleName$Params, context?: HttpContext): Observable<Array<PermissionName>> {
    return this.getPermissionsByRoleName$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionName>>): Array<PermissionName> => r.body)
    );
  }

  /** Path part for operation `updateRole()` */
  static readonly UpdateRolePath = '/api/role/name/{roleName}';

  /**
   * Update Role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole$Response(params: UpdateRole$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
    return updateRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole(params: UpdateRole$Params, context?: HttpContext): Observable<Role> {
    return this.updateRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<Role>): Role => r.body)
    );
  }

  /** Path part for operation `deleteRole()` */
  static readonly DeleteRolePath = '/api/role/name/{roleName}';

  /**
   * Delete Role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole$Response(params: DeleteRole$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
    return deleteRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole(params: DeleteRole$Params, context?: HttpContext): Observable<Role> {
    return this.deleteRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<Role>): Role => r.body)
    );
  }

  /** Path part for operation `getAllPermissions()` */
  static readonly GetAllPermissionsPath = '/api/role/permission/all';

  /**
   * Get All Permissions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPermissions$Response(params?: GetAllPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionName>>> {
    return getAllPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Permissions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPermissions(params?: GetAllPermissions$Params, context?: HttpContext): Observable<Array<PermissionName>> {
    return this.getAllPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionName>>): Array<PermissionName> => r.body)
    );
  }

  /** Path part for operation `getPermissionsByRoleId()` */
  static readonly GetPermissionsByRoleIdPath = '/api/role/{roleId}';

  /**
   * Get Permissions By Role Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPermissionsByRoleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissionsByRoleId$Response(params: GetPermissionsByRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionName>>> {
    return getPermissionsByRoleId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Permissions By Role Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPermissionsByRoleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPermissionsByRoleId(params: GetPermissionsByRoleId$Params, context?: HttpContext): Observable<Array<PermissionName>> {
    return this.getPermissionsByRoleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PermissionName>>): Array<PermissionName> => r.body)
    );
  }

  /** Path part for operation `updateRole_1()` */
  static readonly UpdateRole_1Path = '/api/role/{roleId}';

  /**
   * Update Role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRole_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole_1$Response(params: UpdateRole_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
    return updateRole_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRole_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole_1(params: UpdateRole_1$Params, context?: HttpContext): Observable<Role> {
    return this.updateRole_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Role>): Role => r.body)
    );
  }

  /** Path part for operation `deleteRole_1()` */
  static readonly DeleteRole_1Path = '/api/role/{roleId}';

  /**
   * Delete Role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRole_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole_1$Response(params: DeleteRole_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
    return deleteRole_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRole_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole_1(params: DeleteRole_1$Params, context?: HttpContext): Observable<Role> {
    return this.deleteRole_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Role>): Role => r.body)
    );
  }

  /** Path part for operation `getUsersByRoleId()` */
  static readonly GetUsersByRoleIdPath = '/api/role/{roleId}/user';

  /**
   * Get Users By Role Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersByRoleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersByRoleId$Response(params: GetUsersByRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getUsersByRoleId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Users By Role Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersByRoleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersByRoleId(params: GetUsersByRoleId$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getUsersByRoleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

}
